function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.333h512V426.67H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M85.334 85.33L256 255.996V85.33zM0 426.662h85.334L256 255.996H0zm426.666 0L256 255.996v170.666zm0-341.332L256 255.996h256V85.33z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M196.638 204.054L256 211.475l59.362-7.421v-35.618l-23.745 11.873L256 144.692l-35.617 35.617-23.745-11.873z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M256 345.04c-32.732 0-59.362-26.63-59.362-59.362v-59.36l22.261-22.262h74.203l22.261 22.262v59.36c-.001 32.732-26.631 59.362-59.363 59.362z",
  fill: "#d80027"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M256 322.779c-20.458 0-37.101-16.643-37.101-37.101v-59.361h74.203v59.361c-.001 20.457-16.644 37.101-37.102 37.101z",
  fill: "#f0f0f0"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M196.641 204.05h22.261v22.261h-22.261zm96.457 0h22.261v22.261h-22.261zm0 48.24h22.261v22.261h-22.261zm-96.457 0h22.261v22.261h-22.261zM256 322.779c-3.877 0-7.615-.6-11.13-1.709v22.908c3.608.688 7.325 1.062 11.13 1.062s7.522-.374 11.13-1.062V321.07a36.928 36.928 0 01-11.13 1.709zM219.395 291.7l-17.766 17.766a59.577 59.577 0 0012.876 18.606l15.733-15.733c-5.614-5.426-9.525-12.599-10.843-20.639zm90.976 17.767L292.605 291.7c-1.319 8.038-5.229 15.212-10.843 20.638l15.733 15.733a59.574 59.574 0 0012.876-18.604z",
  fill: "#ffda44"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M248.579 238.683v12.367a7.421 7.421 0 0014.842 0v-12.367h-14.842zm0 49.468v12.367a7.421 7.421 0 0014.842 0v-12.367h-14.842zm22.261-24.734v12.368a7.422 7.422 0 0014.842 0v-12.368H270.84zm-22.261 0v12.368a7.422 7.422 0 0014.842 0v-12.368h-14.842zm-22.261 0v12.368a7.422 7.422 0 0014.842 0v-12.368h-14.842z",
  fill: "#0052b4"
});

const SvgCeuta = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCeuta, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ceuta.066e1129.svg";
export { ForwardRef as ReactComponent };